module.exports = __webpack_public_path__ + "img/oil_free.07526bac.png";